import React from 'react';

interface LessonOpsHeaderProps {
  currentStepLabel: string;
  currentStepTitle: string;
  onBackToTeach: () => void;
}

export const LessonOpsHeader: React.FC<LessonOpsHeaderProps> = ({
  currentStepLabel,
  currentStepTitle,
  onBackToTeach,
}) => (
  <div className="shrink-0 flex items-start justify-between gap-4">
    <div>
      <h1 className="text-2xl font-semibold text-gray-900">Lesson Ops</h1>
      <p className="text-sm text-gray-500">Student-driven live data</p>
      <div className="mt-3 rounded border border-slate-200 bg-slate-50 px-3 py-2">
        <p className="text-xs uppercase tracking-wide text-slate-500">{currentStepLabel || 'Current step'}</p>
        <p className="mt-1 text-sm font-medium text-slate-900">{currentStepTitle || 'Waiting for the next step'}</p>
      </div>
    </div>
    <button
      type="button"
      className="rounded border border-gray-200 bg-white px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50"
      onClick={onBackToTeach}
    >
      Back to Teach
    </button>
  </div>
);
